import React from 'react';

import { Typography } from '@gogame/components';

export default ({ label, typographyVariant, typographyColor }) => (
  <Typography variant={typographyVariant} color={typographyColor}>
    {label}
  </Typography>
);
